<template>
	<div class="solutionBox">
		<div class="banner">
			<div class="name" style="white-space: pre-wrap">{{desList.content}}</div>
			<div class="des flexBox" v-for="item in desList.banners">
				<img  src="../../../assets/img/solution/icon_13.png" class="icon"/>
				<p class="txt">{{item.title}}</p>
			</div>
			<div class="tip">
				<p class="txt">立即咨询</p>
				<div class="tipBox">
					<img src="../../../assets/img/lib/icon_1.png" class="code">
				</div>
			</div>
		</div>
		<div class="serveBox">
			<div class="name">{{serveList.subtitle}}</div>
			<div class="swiper" id="serveSwiper">
				<div class="swiper-wrapper">
					<div class="swiper-slide flexBox" v-for="item in serveList.banners">
						<img :src="item.imageUrl" class="icon">
						<div class="item">
							<div class="txt">{{item.title}}</div>
							<div class="des">{{item.content}}</div>
							<a class="more">
								<p class="tip">服务咨询</p>
								<div class="tipBox">
									<img src="../../../assets/img/lib/icon_1.png" class="code">
								</div>
							</a>
						</div>
					</div>
				</div>
				<div class="swiper-pagination"></div>
			</div>
		</div>
		<div class="planBox">
			<div class="name">城市级算力运营综合一体化解决方案</div>
			<div class="des">
				中明科技以功能齐备、服务高效、监管有力为原则，打造智能感知、高速互联、多元集约、系统调度的算力互联互通和运行服务平台<br>形成区域多云跨域管理、算力异构调度、智能资源匹配、产业生态构建的核心枢纽，打造城市级算力互联示范网，<br>为区域人工产业发展提供可靠的资源保障。
			</div>
		</div>
		<div class="customBox">
			<div class="title">集群定制化服务</div>
			<div class="flexBox info">
				<div class="round">
					<div class="tag">集群定制化服务</div>
					<div class="des">按阶段交付包厢<br>具备6.5兆瓦IT功率交付条件</div>
					<ul class="list">
						<li>
							<img src="../../../assets/img/solution/icon_1.png" class="icon">
							<p class="txt">硬件配置</p>
						</li>
						<li>
							<img src="../../../assets/img/solution/icon_2.png" class="icon">
							<p class="txt">软件优化</p>
						</li>
						<li>
							<img src="../../../assets/img/solution/icon_3.png" class="icon">
							<p class="txt">全周期服务</p>
						</li>
						<li>
							<img src="../../../assets/img/solution/icon_4.png" class="icon">
							<p class="txt">运维支持</p>
						</li>
						<li>
							<img src="../../../assets/img/solution/icon_5.png" class="icon">
							<p class="txt">绿色化、定制化</p>
						</li>
						<li>
							<img src="../../../assets/img/solution/icon_6.png" class="icon">
							<p class="txt">集群交付</p>
						</li>
					</ul>
				</div>
				<ul class="lineBox">
					<li>
						<p class="name">规划部署</p>
						<p class="txt">新一代大模型训练专用加速模块，支持万亿参<br>数模型全量训练，吞吐效率较前代提升 110%</p>
					</li>
					<li>
						<p class="name">支持</p>
						<p class="txt">IB 或 RoCE 组网</p>
					</li>
				</ul>
			</div>
		</div>
		<div class="cloudBox">
			<!-- <div class="title">集群定制化服务</div> -->
			<div class="flexBox">
				<ul class="imgList row">
					<li>
						<img src="../../../assets/img/solution/icon_7.png" class="icon">
						<p class="txt">强大计算能力</p>
					</li>
					<li>
						<img src="../../../assets/img/solution/icon_8.png" class="icon">
						<p class="txt">灵活资源配置</p>
					</li>
					<li>
						<img src="../../../assets/img/solution/icon_9.png" class="icon">
						<p class="txt">使用多场景</p>
					</li>
					<li>
						<img src="../../../assets/img/solution/icon_10.png" class="icon">
						<p class="txt">弹性服务</p>
					</li>
					<li>
						<img src="../../../assets/img/solution/icon_11.png" class="icon">
						<p class="txt">按需租用</p>
					</li>
				</ul>
				<img src="../../../assets/img/solution/icon_12.png" class="preView">
			</div>
		</div>
	</div>
</template>

<script>
	import Swiper, {
		Autoplay,
		Grid,
		Navigation,
		Pagination
	} from 'swiper';
	Swiper.use([Autoplay, Grid, Navigation, Pagination]);
	export default {
		name: 'Solution',
		components: {

		},
		data() {
			return {
				desList:[],
				serveList: [],
			}
		},
		mounted() {
			this.getData();
			
		},
		methods: {
			getData(){
				this.$req("get","/api/cms/bannerCategory/getByCode/solution_info").then((res)=>{
					this.desList = res.data;
				});
				
				this.$req("get","/api/cms/bannerCategory/getByCode/solution_hyjs").then((res)=>{
					this.serveList = res.data;
					this.updateServe();
				});
			},
			updateServe() {
				new Swiper('#serveSwiper', {
					loop: true,
					autoplay: {
						delay: 3000,
						disableOnInteraction: false
					},
					pagination: {
						el: '.swiper-pagination',
						clickable: true,
						renderBullet: (index, className) => {
							return '<span class="tab ' + className + '">' + this.serveList.banners[
								index].title + "</span>";
						},
					},
				})
			},
		}
	}
</script>

<style scoped>
	@import url("../../../assets/css/portal/solution.css");
</style>